<template>
  <v-row>
    <v-col cols="12" md="4" >
      <v-radio-group v-model="value.tipo" row dense
        :rules="[
          this.$validators.string.required,
        ]">
        <v-radio
          label="Sintético"
          value="S"
        ></v-radio>
        <v-radio
          label="Analítico"
          value="A"
        ></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" md="4">
      <v-switch
        v-model="value.flgEmpresaEstrangeira"
        true-value="S"
        false-value="N"
        label="Empresa estrangeira?"
        inset
      />
    </v-col>          
    <v-col cols="12" md="4">
      <v-switch
        v-model="value.esconderDados"
        :label="'Esconder dados sensíveis? (' + (value.esconderDados === 'S' ? 'Sim' : 'Não') + ') '"
        :true-value="'S'"
        :false-value="'N'"
        inset
      />
    </v-col>           
    <v-col cols="12" md="8">
      <v-text-field label="Razão Social/Nome Fantasia"
                    dense
                    v-model.trim="value.nome"/>
    </v-col>  
    <v-col cols="12" md="4">
      <v-text-field label="CNPJ"
                    dense
                    placeholder="99.999.999/9999-99"
                    v-mask="'##.###.###/####-##'"
                    v-model.trim="value.cnpj"/>
    </v-col>
    <v-col cols="12" sm="4">
      <lookup-dominio 
        label="Status" 
        :hidden-clear="false"
        v-model="value.flgStatus"
        :type="lookups.status"/>
    </v-col>      
    <v-col cols="12" md="4">
      <search-box
          label="Setor"
          popup-label="Selecione um Setor"
          :id.sync="value.idSetor"
          :descricao.sync="value.descricaoSetor"
          :hidden-clear="false"
          :value="setor"
          :loader-fn="loadeSetor"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Setor encontrado
          </p>
        </template>
      </search-box>
    </v-col>
    <v-col cols="12" md="4">
      <search-box
          label="Porte"
          popup-label="Selecione um Porte"
          :id.sync="value.idPorte"
          :descricao.sync="value.descricaoPorte"
          :hidden-clear="false"
          :value="porte"
          :loader-fn="loadePorte"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Porte encontrado
          </p>
        </template>
      </search-box>
    </v-col>
    <!-- <v-col cols="12" md="3">
      <search-box
          label="Ramo de Atuação"
          popup-label="Selecione um Ramo de Atuação"
          :id.sync="value.idRamoAtuacao"
          :descricao.sync="value.descricaoRamoAtuacao"
          :hidden-clear="false"
          :value="ramoAtuacao"
          :loader-fn="loadeRamoAtuacao"
          item-key="id"
          item-text="descricao">
        <template v-slot:empty>
          <p class="ma-2">
            Nenhum Ramo de Atuação encontrado
          </p>
        </template>
      </search-box>
    </v-col>  -->
    <v-col cols="12" sm="4">
      <lookup-dominio 
        label="Estado"
        :hidden-clear="false"
        v-model="value.estado"
        :type="lookups.estado"/>
    </v-col>  
    <v-col cols="12" sm="4">
      <v-text-field label="Data Inicio Cadastro"
          dense
          type="date"
          v-model="value.dtInicio"
          :rules="[
              v => this.$validators.string.lessThanOrEquals(v, 10)
          ]"/>
    </v-col>
    <v-col cols="12" sm="4">
      <v-text-field label="Data Fim Cadastro"
            dense
            type="date"
            v-model="value.dtFim"
            :rules="[
                v => this.$validators.string.lessThanOrEquals(v, 10)
            ]"/>
    </v-col>        
  </v-row>
</template>

<script>

import {ItemDeDominio} from "../../../../api/itemsDominio";
import LookupDominio from "../../common/LookupDominio";
import OrderInput from "../../common/OrderInput";
import SearchBox from "../../common/SearchBox";
//PKs
import {findAll as findAllSetor} from "@/api/setor";
import {findAll as findAllPorte} from "@/api/porte";
import {findAll as findAllRamoAtuacao} from "@/api/ramoAtuacao";

export default {
  name: "RelatorioFornecedorForm",
  components: {
    SearchBox,
    LookupDominio,
    OrderInput
  },
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      lookups: {
        estado: ItemDeDominio.COMBO_ESTADO, 
        status: ItemDeDominio.STATUS_MODERACAO,
      },
    }
  },
  watch: {
  },
  computed: {
    setor(){
      if (this.value.idSetor == null) return null;
      return {
        id: this.value.idSetor,
        descricao: this.value.descricaoSetor
      }      
    },
    porte(){
      if (this.value.idPorte == null) return null;
      return {
        id: this.value.idPorte,
        descricao: this.value.descricaoPorte
      }      
    },
    ramoAtuacao(){
      if (this.value.idRamoAtuacao == null) return null;
      return {
        id: this.value.idRamoAtuacao,
        descricao: this.value.descricaoRamoAtuacao
      }      
    },
  },
  methods: {
    loadeSetor(page, search) {
      return findAllSetor(page, {
        nome: search
      })
    },
    loadePorte(page, search) {
      return findAllPorte(page, {
        nome: search
      })
    },
    loadeRamoAtuacao(page, search) {
      return findAllRamoAtuacao(page, {
        nome: search
      })
    }, 
  }
}
</script>

<style scoped lang="scss">

</style>